module.exports = __webpack_public_path__ + "static/media/organizer_1.80459af3.jpg";